import { createFileRoute } from "@tanstack/react-router";

import AddBandsintown from "@/features/onboarding/AddBandsintown";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-bandsintown")({
  component: () => (
    <BasicLayout>
      <AddBandsintown />
    </BasicLayout>
  ),
});
